import React, { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";
import UserInformation from "./profile/UserInformation";

const MemberList = ({ tripId, refreshKey, compact = false }) => {
  const [members, setMembers] = useState([]);
  const [error, setError] = useState("");
  const [deletingMemberId] = useState(null);
  const [expandedMemberId, setExpandedMemberId] = useState(null);

  const fetchMembers = async () => {
    if (!tripId) return;
    const token = localStorage.getItem("token");

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/tripmembers/trip_members/${tripId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!response.ok) {
        throw new Error(`Server Error，Status Code：${response.status}`);
      }

      const data = await response.json();
      setMembers(data);
      setError("");
    } catch (error) {
      console.error(error);
      setError("Unable to get member");
      setMembers([]);
    }
  };

const handleDeleteMember = async (userId) => {
  const token = localStorage.getItem("token");

  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/tripmembers/trip_members/${tripId}/${userId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (res.status === 204) {
      alert("Member deleted");
      fetchMembers(); // 重新取得成員
    } else {
      const data = await res.json();
      if (res.status === 409 && data.detail.includes("share records")) {
        const confirmDelete = window.confirm("This member has shared expenses. Do you want to proceed with deletion?");
        if (confirmDelete) {
          await fetch(`${process.env.REACT_APP_API_URL}/tripmembers/trip_members/${tripId}/${userId}?force=true`, {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          alert("Member force-deleted with shared expenses adjusted");
          fetchMembers();
        }
      } else {
        alert("Delete failed: " + data.detail);
      }
    }
  } catch (err) {
    console.error("Error deleting member", err);
  }
};

  useEffect(() => {
    fetchMembers();
	// eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tripId, refreshKey]);

if (compact) {
  return (
    <div className="flex gap-2">
      {members.map((member) => (
        <img
          key={member.user_id}
          src={`${process.env.REACT_APP_API_URL}${member.avatar_url}` || "/api/uploads/avatars/default-avatar.png"}
          alt={member.username}
          className="w-8 h-8 rounded-full object-cover border"
          title={member.username}
        />
      ))}
    </div>
  );
}

  return (
    <div className="space-y-4 container">
      {error && <p className="text-red-500">{error}</p>}

      {!error && (
        <h3 className="heading text-primary">
          Member List（{members.length} person）
        </h3>
      )}

      {members.length === 0 && !error && (
        <p className="text-gray-500">No Member at the moment</p>
      )}

      {members.length > 0 && (
        <ul className="mt-2 space-y-2">
		{members.map((member) => {
		  const showPassport = member.profile?.permissions?.show_passport;
		  const showMemberships = member.profile?.permissions?.show_memberships;
		  const showInfo = expandedMemberId === member.user_id;

		  return (
			<li
			  key={member.user_id}
			  className="card bg-white shadow-sm rounded-lg"
			>
			  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-2 sm:space-y-0">
                {/* 頭像與名稱 */}			  
				<div className="flex items-center space-x-3">
				  <img
					src={`${process.env.REACT_APP_API_URL}${member.avatar_url}` || "/api/uploads/avatars/default-avatar.png"}
					alt={`${member.username}'s avatar`}
					className="w-10 h-10 rounded-full object-cover border"
				  />
				  <span className="text-gray-800 font-medium">{member.username}</span>
				</div>
                {/* 操作按鈕 */}				
				<div className="flex space-x-2 justify-end">
				  {(showPassport || showMemberships) && (
					<button
					  onClick={() =>
						setExpandedMemberId(showInfo ? null : member.user_id)
					  }
					  className="text-blue-600 hover:underline text-sm"
					>
					  {showInfo ? "Hide Info" : "Show Info"}
					</button>
				  )}
				  <button
					onClick={() => handleDeleteMember(member.user_id)}
					disabled={deletingMemberId === member.user_id}
					className="text-accent hover:text-red-700"
				  >
					{deletingMemberId === member.user_id ? "..." : <Trash2 size={20} />}
				  </button>
				</div>
			  </div>

			  {/* 顯示 UserInformation */}
			  {showInfo && (
				<div className="mt-4 border-t pt-4">
				  <UserInformation
					profile={member.profile}
					setProfile={() => {}}
					countries={[]} // 或根據實際情況傳入
				  />
				</div>
			  )}
			</li>
		  );
		})}
        </ul>
      )}
    </div>
  );
};

export default MemberList;
